import _ from 'lodash';

const FONT_SIZE = 'auto';

function stylesToString(obj) {
    return Object.entries(obj)
        .map(([key, val]) => `${key}:${val}`)
        .join(';');
}
const DEFAULT_STYLES = { 'font-size': FONT_SIZE };
const DEFAULT_TEXT_STYLES = { ...DEFAULT_STYLES };
const DEFAULT_TYPE_STYLES = { ...DEFAULT_STYLES, color: 'white', padding: '2px 4px', 'border-radius': '2px' };
const SUCCESS_COLOR = '#26bfa5';
const INFO_COLOR = '#9b5de5';
const ERROR_COLOR = '#ff6542';
const TYPE_STYLING_MAP = {
    success: { 'background-color': SUCCESS_COLOR },
    info: { 'background-color': INFO_COLOR },
    error: { 'background-color': ERROR_COLOR },
};
const TEXT_STYLING_MAP = {
    success: { color: SUCCESS_COLOR },
    info: { color: INFO_COLOR },
    error: { color: ERROR_COLOR },
};
type STYLING_MAP = Record<string, Record<string, string>>;
export class LoggerClass {
    TYPE_STYLING_MAP: STYLING_MAP;
    TEXT_STYLING_MAP: STYLING_MAP;
    constructor(typeStylingMap: STYLING_MAP = null, textStylingMap: STYLING_MAP = null) {
        this.TYPE_STYLING_MAP = typeStylingMap || TYPE_STYLING_MAP;
        this.TEXT_STYLING_MAP = textStylingMap || TEXT_STYLING_MAP;
    }
    log(type: 'success' | 'error' | 'info', message: any, ...optionalParams: any[]): void {
        const msgs = [`%c${type.toUpperCase()}%c `];
        const args: any[] = [
            stylesToString({ ...DEFAULT_TYPE_STYLES, ...this.TYPE_STYLING_MAP[type] }),
            stylesToString({ ...DEFAULT_TEXT_STYLES, ...this.TEXT_STYLING_MAP[type] }),
        ];
        for (const msg of [message, ...optionalParams]) {
            if (_.isString(msg)) {
                msgs.push('%s');
                args.push(msg);
                continue;
            }

            msgs.push(' %o ');
            args.push(msg);
        }
        console.log(msgs.join(''), ...args);
    }
    success(message: any, ...optionalParams: any[]): void {
        this.log('success', message, ...optionalParams);
    }
    info(message: any, ...optionalParams: any[]): void {
        this.log('info', message, ...optionalParams);
    }
    error(message: any, ...optionalParams: any[]): void {
        this.log('error', message, ...optionalParams);
    }
}
export default new LoggerClass();
